import { Model } from '@/models/Model';
export class SubjectLabel extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'SubjectLabel';
        this.$endpoint = '/subject-labels';
        this.$fillable = [
            'name',
        ];
    }
}
